import { render, staticRenderFns } from "./SchoolView.vue?vue&type=template&id=2c53a13b&scoped=true&"
import script from "./SchoolView.vue?vue&type=script&lang=js&"
export * from "./SchoolView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53a13b",
  null
  
)

export default component.exports